import { css } from "@emotion/react";

export const flexColumn = css(`
  display: flex;
  flex-direction: column;
`);

export const flexRow = css(`
  display: flex;
  flex-direction: row;
`);

export const centerVertical = css(`
  align-items: center;
`);

export const centerHorizontal = css(`
  justify-content: center;
`);

export const alignEnd = css(`
  align-items: flex-end;
  justify-content: flex-end;
`);

export const spaceBetween = css(`
  justify-content: space-between;
`);
